module.exports = __webpack_public_path__ + "img/getstarted_artwork@2x.cf6a7a8e.png";